<ion-header>
    <ion-toolbar class="header-color ion-text-center">
      <ion-title>{{displayName}}</ion-title>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="home"></ion-back-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
      <div id="chatcontainer" style="height: 85vh;">
      </div>
  </ion-content>
  
  